// extracted by mini-css-extract-plugin
export default {"title":"ExamBox_title__4XQaE"};